StepController = App.loadClass 'grower::Angular/Data/PlantingRx/StepController'

class exports.LayersController extends StepController
    constructor: (@scope, @transitions, @map, @visualLayers, @layerManager, @loader) ->
        super(@scope, @transitions, @map)
        return if @scope.aborted

        @scope.available_layers = []
        @scope.toggleLayer = @toggleLayer

        load_msg = @loader.overMapAndSidebar 'Loading...'

        @visualLayers.byField(@scope.rx.fields_id, @scope.rx.spp_id, @scope.rx.year).then (response) =>

            @scope.available_layers = response.data.data.results # Layers that can be used
            @scope.usable_layers = response.data.data.layers     # Layer types that can be used
            @reselectLayers() # show layers we previous selected again

            load_msg.hide()

        @setUpMap()

        @scope.$watchCollection 'rx.visual_layers', (value) =>
            if value.length is 0
                @scope.setValidity false
            else
                @scope.setValidity true


    toggleLayer: (layer) =>
        layer.selected ?= false
        layer.selected = not layer.selected

        # Will be used to record in the scope.rx.visual_layers
        # array, which is used to maintain list of selections between
        # steps.
        unique_visual_layer =
            id: layer.id
            type: layer.type
            name: layer.name

        if layer.selected
            if not layer.map_service?
                # Retrieves an instance of the given layer type
                layer.map_service = @layerManager.get(layer.type)
                layer.onSlide = (ev, ui) ->
                    layer.map_service?.setOpacity(ui.value)

            # Display the layer (complete with loading msg!)
            load_msg = @loader.overSidebar 'Loading Layer...'
            layer.map_service.display({ id: layer.id }, @mapLayer).then () =>
                load_msg.hide()
            .catch (response) =>
                # TODO: show an error message somewhere?
                load_msg.hide()

            # Track the layer in our visual layers array. This will
            # be used to keep track between steps of which layers we chose.
            # If the layer is already in visual_layers, don't re-add it.
            # The known case for this is when re-visualizing layers.
            if @compareLayersToSelectedLayer(@scope.rx.visual_layers, unique_visual_layer).length is 0
                @scope.rx.visual_layers.push unique_visual_layer
            else
                # ensure that all layers include crop names if needed
                layersComparison = @compareLayersToSelectedLayer(@scope.rx.visual_layers, layer)
                layer.name = unique_visual_layer.name for layer in layersComparison

        else
            layer.map_service?.hide(@mapLayer)

            # Remove the layer from our visual layers array. We no longer
            # want to track it between steps.
            _.remove @scope.rx.visual_layers,
                id: unique_visual_layer.id
                type: unique_visual_layer.type


    # If we previously selected any layers for display,
    # ensure they are displayed.
    reselectLayers: () =>
        for selected_layer in @scope.rx.visual_layers when selected_layer.type? and selected_layer.id?
            @toggleLayer layer for layer in @compareLayersToSelectedLayer @scope.available_layers, selected_layer

    compareLayersToSelectedLayer: (layers, selected_layer) ->
        # return any available layers that match the type and id for the current selected layer
        return _.filter layers,
            type: selected_layer.type
            id: selected_layer.id
